var validator = require('email-validator');

const emailIsValid = email => {
  if (!email) return false;
  return validator.validate(email);
}

export default emailIsValid;
